import React from 'react';
import { Stack, Chip, Box } from '@mui/material';
import PlusIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';
import { VTypography } from '@venti-components';
import VTextInput from '../../../../Venti-UI-Kit/VInputs/VTextInput/VTextInput';
import VSelectInput from '../../../../Venti-UI-Kit/VInputs/VSelectInput/VSelectInput';
import { useProducerPayoutConfigForm } from './hook';
import Button from '../../../../Components/Buttons/Button/Button';
import VIconButton from '../../../../Components/Buttons/IconButton/IconButton';
import styles from './styles';
import { VAT_STATUS_OPTIONS, REBATE_TYPE_OPTIONS } from './interfaces';

const ProducerPayoutConfigForm = ({ payoutConfig, onSubmit, classes }) => {
  const {
    formState,
    formValues,
    handleInputChange,
    emailInput,
    setEmailInput,
    handleEmailAdd,
    handleEmailDelete,
    handleRebateTypeChange,
    handleSubmit,
  } = useProducerPayoutConfigForm(payoutConfig, onSubmit);

  return (
    <Box className={classes.form}>
      <Stack gap={2}>
        <VTypography variant="h5">Datos fiscales</VTypography>
        <VTextInput
          title="CUIT"
          name="taxId"
          value={formState.taxId.value}
          onChange={handleInputChange}
          errorMessage={formState.taxId.error}
          fullWidth
        />
        <VTextInput
          title="Nombre fiscal"
          name="taxName"
          value={formState.taxName.value}
          onChange={handleInputChange}
          errorMessage={formState.taxName.error}
          fullWidth
        />
        <VSelectInput
          title="Condición IVA"
          name="vatStatus"
          value={formState.vatStatus.value}
          onChange={handleInputChange}
          errorMessage={formState.vatStatus.error}
          options={VAT_STATUS_OPTIONS}
          fullWidth
        />
        <VTypography variant="h5">Rebates</VTypography>
        <VSelectInput
          title="Tipo de rebate por defecto"
          name="defaultRebateType"
          value={formState.defaultRebateType.value}
          onChange={handleRebateTypeChange}
          errorMessage={formState.defaultRebateType.error}
          options={REBATE_TYPE_OPTIONS}
          fullWidth
        />
        {formState.defaultRebateType.value === 'PERCENTAGE' && (
          <VTextInput
            title="Porcentaje de rebate (%)"
            name="defaultRebatePercentage"
            type="number"
            value={formState.defaultRebatePercentage.value}
            onChange={handleInputChange}
            errorMessage={formState.defaultRebatePercentage.error}
            fullWidth
          />
        )}
        {formState.defaultRebateType.value === 'REVENUE_SHARE' && (
          <VTextInput
            title="Revenue Share (%)"
            name="defaultRevenueSharePercentage"
            type="number"
            value={formState.defaultRevenueSharePercentage.value}
            onChange={handleInputChange}
            errorMessage={formState.defaultRevenueSharePercentage.error}
            fullWidth
          />
        )}
        <Box>
          <Stack direction="row" gap={1} alignItems="center">
            <VTextInput
              title="Emails para liquidación"
              value={emailInput}
              errorMessage={formState.settlementRecipientEmails.error}
              onChange={(e) => setEmailInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleEmailAdd();
              }}
              size="small"
              endAdornment={<VIconButton Icon={<PlusIcon />} onClick={handleEmailAdd} size={30} />}
              fullWidth
            />
          </Stack>
          <Stack direction="row" gap={1} mt={1} flexWrap="wrap">
            {formValues.settlementRecipientEmails.map((email) => (
              <Chip key={email} label={email} onDelete={() => handleEmailDelete(email)} />
            ))}
          </Stack>
        </Box>
        <Button onClick={handleSubmit} title="Guardar" variant="contained" />
      </Stack>
    </Box>
  );
};

export default withStyles(styles)(ProducerPayoutConfigForm);
